"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDecisionactionFrozen = exports.IDecisionactionInactive = exports.IDecisionactionAction = void 0;
var IDecisionactionAction;
(function (IDecisionactionAction) {
    IDecisionactionAction[IDecisionactionAction["RETURN_AN_ERROR_AND_DECLINE_1"] = 1] = "RETURN_AN_ERROR_AND_DECLINE_1";
    IDecisionactionAction[IDecisionactionAction["FOR_TXN_DECISION_HOLD_3"] = 3] = "FOR_TXN_DECISION_HOLD_3";
    IDecisionactionAction[IDecisionactionAction["FOR_TXN_DECISION_RESERVE_4"] = 4] = "FOR_TXN_DECISION_RESERVE_4";
    IDecisionactionAction[IDecisionactionAction["THIS_DECISION_RESULTS_IN_THE_MERCHANTS_CURRENT_ACTIVITY_EITHER_TRANSACTION_OR_PAYOUT_BEING_DECLINED_5"] = 5] = "THIS_DECISION_RESULTS_IN_THE_MERCHANTS_CURRENT_ACTIVITY_EITHER_TRANSACTION_OR_PAYOUT_BEING_DECLINED_5";
})(IDecisionactionAction = exports.IDecisionactionAction || (exports.IDecisionactionAction = {}));
var IDecisionactionInactive;
(function (IDecisionactionInactive) {
    IDecisionactionInactive[IDecisionactionInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    IDecisionactionInactive[IDecisionactionInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(IDecisionactionInactive = exports.IDecisionactionInactive || (exports.IDecisionactionInactive = {}));
var IDecisionactionFrozen;
(function (IDecisionactionFrozen) {
    IDecisionactionFrozen[IDecisionactionFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    IDecisionactionFrozen[IDecisionactionFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(IDecisionactionFrozen = exports.IDecisionactionFrozen || (exports.IDecisionactionFrozen = {}));
